/**
 * 将SVG字符串转换为Base64数据URL
 * @param {string} svgStr - SVG字符串
 * @returns {string} Base64数据URL
 */
export function svgToBase64(svgStr) {
  // 确保SVG字符串是有效的
  if (!svgStr || typeof svgStr !== "string") {
    console.error("Invalid SVG string");
    return "";
  }

  // 编码SVG字符串
  const encodedSvg = encodeURIComponent(svgStr);

  // 创建Base64数据URL
  return `data:image/svg+xml;base64,${btoa(unescape(encodedSvg))}`;
}

/**
 * 机器人图标1的SVG字符串
 */
export const robotIcon1Svg = `
<svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="19" cy="19" r="19" fill="url(#paint0_linear_42586_37365)"/>
<g filter="url(#filter0_i_42586_37365)">
<circle cx="19.0908" cy="18.9116" r="11.0522" fill="url(#paint1_linear_42586_37365)"/>
</g>
<rect x="18.3066" y="14.2695" width="2.37363" height="5.48901" rx="1.18681" fill="url(#paint2_linear_42586_37365)"/>
<rect x="24.5059" y="15.0117" width="1.92857" height="3.85714" rx="0.964286" fill="url(#paint3_linear_42586_37365)"/>
<path d="M10.4282 15.2812H12.3054C14.109 15.2812 15.5711 16.7434 15.5711 18.547C15.5711 20.3506 14.109 21.8127 12.3054 21.8127H10.4282V15.2812Z" fill="url(#paint4_linear_42586_37365)"/>
<ellipse cx="10.4123" cy="18.5333" rx="2.96703" ry="3.26374" fill="url(#paint5_linear_42586_37365)"/>
<ellipse cx="9.1511" cy="18.5416" rx="2.1511" ry="2.37363" fill="url(#paint6_linear_42586_37365)"/>
<path d="M19.3442 22.6602C20.1406 23.3868 22.5872 24.8524 25.5294 22.8624C24.9815 24.7071 21.4953 27.0989 19.3442 22.6602Z" fill="url(#paint7_linear_42586_37365)"/>
<defs>
<filter id="filter0_i_42586_37365" x="8.03857" y="6.00446" width="22.7228" height="23.9604" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="0.618305" dy="-1.85491"/>
<feGaussianBlur stdDeviation="1.54576"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.621878 0 0 0 0 0.756897 0 0 0 0 0.920342 0 0 0 1 0"/>
<feBlend mode="normal" in2="shape" result="effect1_innerShadow_42586_37365"/>
</filter>
<linearGradient id="paint0_linear_42586_37365" x1="30.78" y1="34.2" x2="5.7" y2="4.56" gradientUnits="userSpaceOnUse">
<stop offset="0.00480769" stop-color="#84E2F4"/>
<stop offset="0.567308" stop-color="#649FF6"/>
<stop offset="1" stop-color="#8C82F9"/>
</linearGradient>
<linearGradient id="paint1_linear_42586_37365" x1="19.0908" y1="7.85937" x2="19.0908" y2="29.9638" gradientUnits="userSpaceOnUse">
<stop stop-color="#E6FAFF"/>
<stop offset="1" stop-color="#E6E5FF"/>
</linearGradient>
<linearGradient id="paint2_linear_42586_37365" x1="19.4935" y1="14.2695" x2="19.4935" y2="19.7585" gradientUnits="userSpaceOnUse">
<stop stop-color="#8686F9"/>
<stop offset="1" stop-color="#72B5FF"/>
</linearGradient>
<linearGradient id="paint3_linear_42586_37365" x1="25.4701" y1="15.0117" x2="25.4701" y2="18.8689" gradientUnits="userSpaceOnUse">
<stop stop-color="#8885F9"/>
<stop offset="1" stop-color="#72B5FF"/>
</linearGradient>
<linearGradient id="paint4_linear_42586_37365" x1="12.5711" y1="15.2812" x2="12.5711" y2="21.8127" gradientUnits="userSpaceOnUse">
<stop stop-color="#DAF5F9"/>
<stop offset="1" stop-color="#9DA3FC"/>
</linearGradient>
<linearGradient id="paint5_linear_42586_37365" x1="10.4123" y1="15.2695" x2="10.4123" y2="21.797" gradientUnits="userSpaceOnUse">
<stop stop-color="#68B8FD"/>
<stop offset="1" stop-color="#4141EF"/>
</linearGradient>
<linearGradient id="paint6_linear_42586_37365" x1="9.1511" y1="16.168" x2="9.1511" y2="20.9152" gradientUnits="userSpaceOnUse">
<stop stop-color="#83D2FF"/>
<stop offset="1" stop-color="#7094FF"/>
</linearGradient>
<linearGradient id="paint7_linear_42586_37365" x1="22.3819" y1="22.0979" x2="22.9657" y2="25.0981" gradientUnits="userSpaceOnUse">
<stop stop-color="#8587F8"/>
<stop offset="1" stop-color="#72B5FF"/>
</linearGradient>
</defs>
</svg>
`;

/**
 * 点赞图标的SVG字符串（与 MessageActionsMixin 中的图标保持一致）
 */
export const likeIconSvg = `
<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M9.37227 5.94064V3.19778C9.37227 2.06164 8.45127 1.14062 7.31512 1.14062L4.57227 7.31207V14.8549H12.5403C13.2241 14.8627 13.8092 14.3654 13.9117 13.6892L14.858 7.51778C14.9184 7.11995 14.801 6.71568 14.537 6.41206C14.273 6.10845 13.8889 5.93607 13.4866 5.94064H9.37227Z" stroke="#7886A4" stroke-width="1.4"/>
  <path d="M4.57115 7.24241H2.74029C1.93699 7.2282 1.25027 7.89361 1.14258 8.68976V13.4898C1.25027 14.286 1.93699 14.8754 2.74029 14.8612H4.57115V7.24241Z" stroke="#7886A4" stroke-width="1.4"/>
</svg>
`;

/**
 * 点踩图标的SVG字符串（与 MessageActionsMixin 中的图标保持一致）
 */
export const dislikeIconSvg = `
<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M6.62041 10.055V12.7978C6.62041 13.934 7.5414 14.855 8.67755 14.855L11.4204 8.68356V1.14071H3.45241C2.76856 1.13298 2.18351 1.63026 2.08097 2.30643L1.13468 8.47785C1.0743 8.87567 1.19166 9.27994 1.45569 9.58356C1.71972 9.88718 2.10376 10.0596 2.50611 10.055H6.62041Z" stroke="#7886A4" stroke-width="1.4"/>
  <path d="M11.4219 1.14088H13.2527C14.056 1.12667 14.7428 1.71612 14.8504 2.5123V7.31232C14.7428 8.10847 14.056 8.77414 13.2527 8.75994H11.4219V1.14088Z" stroke="#7886A4" stroke-width="1.4"/>
</svg>
`;

// 选中态：填充为主题蓝色 #05ABFA 的点赞图标
export const likeIconActiveSvg = `
<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.31445 0.445312C8.83707 0.445479 10.0713 1.68049 10.0713 3.20312V5.24512H13.4854C14.0903 5.2405 14.6674 5.50139 15.0645 5.95801C15.463 6.41657 15.64 7.02719 15.5488 7.62793L14.6025 13.7998C14.4477 14.8182 13.5684 15.5665 12.5391 15.5586H4.7998V5.07812L6.85938 0.445312H7.31445ZM3.59961 15.5586H2.74121V15.5576C1.5884 15.5718 0.605114 14.7248 0.450195 13.5811L0.443359 13.5342V8.63965L0.450195 8.59277C0.598757 7.49548 1.54358 6.52661 2.74121 6.54102V6.53906H3.59961V15.5586Z" fill="#05ABFA"/>
</svg>
`;

// 选中态：填充为主题蓝色 #05ABFA 的点踩图标
export const dislikeIconActiveSvg = `
<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.68555 15.5547C7.16293 15.5545 5.92871 14.3195 5.92871 12.7969V10.7549H2.51465C1.9097 10.7595 1.33264 10.4986 0.935547 10.042C0.536984 9.58343 0.359995 8.97281 0.451172 8.37207L1.39746 2.2002C1.55226 1.18182 2.43163 0.433527 3.46094 0.441406H11.2002V10.9219L9.14062 15.5547H8.68555ZM12.4004 0.441406H13.2588V0.442383C14.4116 0.428169 15.3949 1.27523 15.5498 2.41895L15.5566 2.46582V7.36035L15.5498 7.40723C15.4012 8.50452 14.4564 9.47339 13.2588 9.45898V9.46094H12.4004V0.441406Z" fill="#05ABFA"/>
</svg>
`;

/**
 * 机器人图标2的SVG字符串
 */
export const robotIcon2Svg = `
<svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="38" height="38" rx="19" fill="url(#paint0_linear_42612_36165)"/>
<g clip-path="url(#clip0_42612_36165)">
<path d="M25.8375 24.8299C26.6225 24.0681 26.7686 22.3438 26.7686 22.3438C26.7686 22.3438 26.9126 24.0681 27.6998 24.8299C28.487 25.5917 30.1836 25.762 30.1836 25.762C30.1836 25.762 28.4761 25.9431 27.6998 26.694C26.9235 27.4449 26.7686 29.1802 26.7686 29.1802C26.7686 29.1802 26.6225 27.458 25.8375 26.694C25.0524 25.93 23.3471 25.762 23.3471 25.762C23.3471 25.762 25.0612 25.583 25.8375 24.8299Z" fill="white" fill-opacity="0.7"/>
<path d="M23.5899 12.6936C24.8388 11.4831 25.0691 8.74609 25.0691 8.74609C25.0691 8.74609 25.2949 11.4831 26.5505 12.6936C27.8062 13.904 30.498 14.175 30.498 14.175C30.498 14.175 27.7881 14.4596 26.5505 15.6565C25.313 16.8534 25.0691 19.604 25.0691 19.604C25.0691 19.604 24.8433 16.8669 23.5899 15.6565C22.3366 14.446 19.6402 14.175 19.6402 14.175C19.6402 14.175 22.3546 13.8905 23.5899 12.6936Z" fill="white" fill-opacity="0.89"/>
<path d="M12.857 18.7654C14.7387 16.9264 15.086 12.7695 15.086 12.7695C15.086 12.7695 15.4344 16.9264 17.3149 18.7654C19.1734 20.5801 23.2598 21.0135 23.2598 21.0135C23.2598 21.0135 19.1734 21.4458 17.3149 23.2615C15.4344 25.0994 15.086 29.2574 15.086 29.2574C15.086 29.2574 14.7387 25.0994 12.857 23.2615C10.9996 21.4458 6.91215 21.0135 6.91215 21.0135C6.91215 21.0135 10.9996 20.5801 12.857 18.7654Z" fill="white"/>
</g>
<defs>
<linearGradient id="paint0_linear_42612_36165" x1="11.7574" y1="1.19526" x2="33.163" y2="34.1393" gradientUnits="userSpaceOnUse">
<stop stop-color="#57D9FF"/>
<stop offset="0.427885" stop-color="#489AF6"/>
<stop offset="1" stop-color="#8952FF"/>
</linearGradient>
<clipPath id="clip0_42612_36165">
<rect width="23.5862" height="23.5862" fill="white" transform="matrix(-1 0 0 1 30.793 7.20703)"/>
</clipPath>
</defs>
</svg>
`;

/**
 * 用户图标的SVG字符串
 */
export const userIconSvg = `
<svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="19" cy="19" r="19" fill="#9ED9F4" />
  <g clip-path="url(#clip0_user)">
    <path d="M19 19C19.89 19 20.76 18.7361 21.5001 18.2416C22.2401 17.7471 22.8169 17.0443 23.1575 16.2221C23.4981 15.3998 23.5872 14.495 23.4135 13.6221C23.2399 12.7492 22.8113 11.9474 22.182 11.318C21.5526 10.6887 20.7508 10.2601 19.8779 10.0865C19.005 9.91283 18.1002 10.0019 17.2779 10.3425C16.4557 10.6831 15.7529 11.2599 15.2584 11.9999C14.7639 12.74 14.5 13.61 14.5 14.5C14.5 15.6935 14.9741 16.8381 15.818 17.682C16.6619 18.5259 17.8065 19 19 19ZM19 21.25C15.9963 21.25 10 22.7575 10 25.75V28H28V25.75C28 22.7575 22.0037 21.25 19 21.25Z" fill="white" />
  </g>
  <defs>
    <clipPath id="clip0_user">
      <rect width="18" height="18" fill="white" transform="translate(10 10)" />
    </clipPath>
  </defs>
</svg>
`;

/**
 * 获取机器人图标1的Base64 URL
 * @returns {string} Base64 URL
 */
export function getRobotIcon1Base64() {
  return svgToBase64(robotIcon1Svg);
}

/**
 * 获取机器人图标2的Base64 URL
 * @returns {string} Base64 URL
 */
export function getRobotIcon2Base64() {
  return svgToBase64(robotIcon2Svg);
}

/**
 * 获取用户图标的Base64 URL
 * @returns {string} Base64 URL
 */
export function getUserIconBase64() {
  return svgToBase64(userIconSvg);
}

/**
 * 获取点赞图标的Base64 URL
 * @returns {string} Base64 URL
 */
export function getLikeIconBase64() {
  return svgToBase64(likeIconSvg);
}

/**
 * 获取点踩图标的Base64 URL
 * @returns {string} Base64 URL
 */
export function getDislikeIconBase64() {
  return svgToBase64(dislikeIconSvg);
}

/**
 * 获取点赞图标选中态的Base64 URL
 */
export function getLikeIconActiveBase64() {
  return svgToBase64(likeIconActiveSvg);
}

/**
 * 获取点踩图标选中态的Base64 URL
 */
export function getDislikeIconActiveBase64() {
  return svgToBase64(dislikeIconActiveSvg);
}
